import { getLocalStorage, setLocalStorage } from '../stores'

import { STORAGE_KEY__ATTEMPT_CLICKS } from '../variables.ts'

/**
 * Utils
 */
const getItem = () => getLocalStorage(STORAGE_KEY__ATTEMPT_CLICKS)
const setItem = value => setLocalStorage(STORAGE_KEY__ATTEMPT_CLICKS, value)
const getURL = url => {
  try {
    return new URL(url)
  } catch (error) {
    return null
  }
}

/**
 * Attempt Clicks
 */
/**
 * @description Will pop the Attempts data
 */
export function getAttemptClicks() {
  const storageData = getItem()

  if (!Array.isArray(storageData) || storageData.length === 0) {
    return null
  }

  const result = []
  const newStorageData = []
  storageData.forEach(item => {
    const itemPageURL = getURL(item.pageURL)
    if (itemPageURL) {
      const currentPageURL = new URL(window.location.href)
      const itemPagePathname = itemPageURL.pathname.toLowerCase()
      const currentPagePathname = currentPageURL.pathname.toLowerCase()
      const isSameProductPage =
        currentPagePathname.includes(itemPagePathname) ||
        itemPagePathname === currentPagePathname

      if (isSameProductPage) {
        result.push(item)
      } else {
        newStorageData.push(item)
      }
    }
  })

  setItem(newStorageData)

  return result.length > 0 ? result : null
}
export function setAttemptClick(pageURL, eventPath) {
  const attempClicks = getItem() ?? []
  attempClicks.unshift({
    pageURL,
    referrer: window.location.href,
    eventPath
  })

  setItem(attempClicks.slice(0, 36))
}
